import {HOTEL_TYPE} from '@/models-hotel';

const hotelType: HOTEL_TYPE = 'P';
export const hotelName = '포도호텔';
export default hotelType;
